var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonicMdFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.724,
    height: 13.57,
    viewBox: "0 0 8.724 13.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".j{fill:#af6dab;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16.6,6.612a4.362,4.362,0,1,0-5.089,4.3v1.515H9.329v1.454H11.51V15.82h1.454V13.882h2.181V12.428H12.964V10.913A4.361,4.361,0,0,0,16.6,6.612Zm-7.27,0A2.908,2.908,0,1,1,12.237,9.52,2.913,2.913,0,0,1,9.329,6.612Z",
    transform: "translate(-7.875 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicMdFemale);
export default __webpack_public_path__ + "static/media/ionic-md-female.9910ef1c7f6f66473c5be08ec0304e06.svg";
export { ForwardRef as ReactComponent };